import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import type SwiperInstance from 'swiper';
import { useSwiper } from 'swiper/react';

import styles from './Shadow.module.scss';

export const Shadow: React.FC = () => {
	const swiper = useSwiper();
	const [isStart, setIsStart] = useState(false);
	const [isEnd, setIsEnd] = useState(false);

	useEffect(() => {
		swiper.on('progress', (sw: SwiperInstance) => {
			setIsStart(sw.isBeginning);
			setIsEnd(sw.isEnd);
		});
		return () => {
			swiper.off('progress');
		};
	}, [swiper]);

	return (
		<>
			<div className={cx(styles.shadow, styles.start, { [styles.show]: !isStart })} />
			<div className={cx(styles.shadow, styles.end, { [styles.show]: !isEnd })} />
		</>
	);
};
